import React, {useRef} from "react"
import _ from "lodash"
import {isNumeric} from "rxjs/internal-compatibility"
import {ValueGetterParams} from "ag-grid-community/dist/lib/entities/colDef"
import {useSelector} from "react-redux"
import {ColumnApi} from "ag-grid-community/dist/lib/columns/columnApi"
import {getContext, getSortableTableData} from "../redux/refdb.selector"
import {
    setColumnWidthsAction,
    setDisplayDataFilteringAction,
    setDisplayDataSortingAction,
} from "../redux/refdb.actions"
import TableColumn from "../../@biocrates-common-repo/core/models/tableColumn"
import MemoizedSortableTable from "../../@biocrates-common-repo/core/components/table/SortableTable"

function decimalSchema(param: any) {
    if (isNumeric(param)) {
        const values: number = +param
        if (values === 0) {
            return 0
        }
        if (values < 0.0001) {
            return +values.toFixed(5)
        }
        if (values < 0.01) {
            return +values.toFixed(4)
        }
        if (values < 0.1) {
            return +values.toFixed(3)
        }
        if (values < 1) {
            return +values.toFixed(2)
        }
        if (values < 10) {
            return +values.toFixed(1)
        }
        return +values.toFixed(0)
    }
    // values >= 10	No decimals
    // values >= 1 & values < 10	1 decimal
    // values >= 0.1 & values < 1	2 decimals
    // values >= 0.01 & values < 0.1	3 decimals
    // values >= 0.0001 & values < 0.01	4 decimals
    // values < 0.0001 	5 decimals
    //
    return param
}

const getValue = (cellValue) => {
    if (cellValue !== undefined && cellValue.value !== undefined) {
        return cellValue.value
    }
    return cellValue
}

const getValueWithDefault = (cellValue, defaultValue) => {
    if (cellValue !== undefined && cellValue.value !== undefined) {
        return cellValue.value
    }
    return defaultValue || ""
}

const customValueGetter = (params: ValueGetterParams, column: TableColumn) => {
    // eslint-disable-next-line no-nested-ternary
    const cellValue = !_.isNil(params.data[column.id])
        ? params.data[column.id]
        : !_.isNil(params.data.values)
        ? getValue(params.data.values)[column.id]
        : ""
    return column.decimalSchema
        ? decimalSchema(getValue(cellValue))
        : getValueWithDefault(cellValue, column.default)
}

const DisplayDataTable: React.FC = () => {
    // bof this allow to refresh visibility of column
    useSelector(getContext)

    const columnApi = useRef<ColumnApi>(null)
    const onGridReady = (params) => {
        columnApi.current = params.columnApi
    }
    // eof
    return (
        <div style={{height: "100%", paddingTop: "0.5em"}}>
            <MemoizedSortableTable
                sortableDataSelector={getSortableTableData}
                numFrozenColumns={0}
                setSortingAction={setDisplayDataSortingAction}
                setFilteringAction={setDisplayDataFilteringAction}
                setColumnWidthsAction={setColumnWidthsAction}
                customValueGetter={customValueGetter}
                disableInternalSorting={false}
                disableCustomRenderer
                rowSelection="multiple"
                rowHeight={20}
                onGridReady={onGridReady}
            />
        </div>
    )
}

export default DisplayDataTable
